const botPatterns = [
  // --- SEO & social bots ---
  /bot/i,
  /spider/i,
  /crawl/i,
  /slurp/i,
  /facebookexternalhit/i,
  /pinterestbot/i,
  /discordbot/i,
  /telegrambot/i,
  /twitterbot/i,
  /linkedinbot/i,
  /whatsapp/i,
  /preview/i,
  /embedly/i,
  /quora link preview/i,
  /vkShare/i,
  /redditbot/i,
  /snapchat/i,

  // --- SEO & marketing crawlers ---
  /semrushbot/i,
  /ahrefsbot/i,
  /mj12bot/i,
  /dotbot/i,
  /datadome/i,
  /uptimebot/i,
  /petalbot/i,
  /baiduspider/i,
  /yandexbot/i,
  /bingbot/i,
  /googlebot/i,

  // --- ML / AI / research bots ---
  /gptbot/i,
  /claudebot/i,
  /chatgpt/i,
  /openai/i,
  /anthropic/i,
  /cohere/i,
  /perplexitybot/i,

  // --- Common HTTP clients / scrapers ---
  /python/i,
  /python-requests/i,
  /aiohttp/i,
  /httpx/i,
  /curl/i,
  /wget/i,
  /axios/i,
  /okhttp/i,
  /httpclient/i,
  /go-http-client/i,
  /java/i,
  /node-fetch/i,
  /libwww-perl/i,
  /php/i,
  /ruby/i,
  /rust/i,
  /dart/i,
];

export function isBotUserAgent(userAgent: string): boolean {
  if (!userAgent) return false;

  return botPatterns.some((pattern) => pattern.test(userAgent));
}
